// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"7820baae","318":"448fc23a","377":"d73799ba","640":"c949a79d","683":"ac1d611b","700":"8055dba0","897":"a677347a"}[chunkId] + ".chunk.js";
};